import {
  IScribeNote,
  IScribeSession,
  ScribeSessionCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  DocumentReference,
  Firestore,
  IReffable,
  WithRef,
  multiUndeleted,
  query$,
  subCollection,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class ScribeNote {
  static init(overrides: AtLeast<IScribeNote, 'content'>): IScribeNote {
    return {
      deleted: false,
      ...overrides,
    };
  }

  static col(
    session: IReffable<IScribeSession>
  ): CollectionReference<IScribeNote> {
    return subCollection<IScribeNote>(
      session.ref,
      ScribeSessionCollection.Notes
    );
  }

  /**
   * The parent session a note lives under. A note is always stored in a
   * session's {@link ScribeSessionCollection.Notes} subcollection, so this
   * parent ref always resolves — it is never `undefined`.
   */
  static sessionRef(
    note: IReffable<IScribeNote>
  ): DocumentReference<IScribeSession> {
    return Firestore.getParentDocRef<IScribeSession>(note.ref);
  }

  static all$(
    session: IReffable<IScribeSession>
  ): Observable<WithRef<IScribeNote>[]> {
    return query$(ScribeNote.col(session)).pipe(multiUndeleted());
  }
}
